export const colors = {
  primary: '#2AB640',
  secondary: '#54CF61',
  black: '#242424',
  gray: '#535353',
  gray2: '#8E8E8E',
  gray3: '#F4F4F4',
  lightGray: '#F1F1F1',
  darkGray: '#595858',
  white: '#ffffff',
  red: '#E43F28',
  red2: '#F06072',
  red3: '#FF7086',
  darkGreen: '#159128',
  blue: '#26C0B7',
}

export const spaces = {
  smaller: '4px',
  small: '8px',
  medium: '16px',
  large: '32px',
  larger: '48px',
}

export const breakpoints = {
  sm: '600px',
  md: '900px',
  lg: '1200px',
  xl: '1800px',
}

export const fontSizes = {
  extraSmall: '10px',
  smaller: '12px',
  small: '14px',
  medium: '16px',
  extaMeduim: '18.2px',
  normal: '20px',
  large: '24px',
  larger: '40px',
  extraLarge: '64px',
}

const theme = {
  colors,
  fontSizes,
  breakpoints,
  spaces,
}

export default theme
